import styled from '@emotion/styled'
import { ReactNode, useState } from 'react'

import { ArrowIcon } from './ArrowIcon'
import { Body } from './Body'
import { Header } from './Header'
import { DisclosureContext } from './useDisclosureContext'
import { theme } from '../../constants/theme'
import { Paragraph } from '../Paragraph'

const DisclosureElement = styled.div<{ floating: boolean }>((props) => ({
  borderBottom: props.floating ? theme.border.style.thin : undefined,
  borderBottomLeftRadius: props.floating
    ? undefined
    : theme.border.radius.normal,
  borderBottomRightRadius: props.floating
    ? undefined
    : theme.border.radius.normal,
  boxShadow: props.floating ? 'none' : theme.boxShadow.normal,
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  ':not(:first-of-type)': {
    borderTop: 'none',
  },
}))

type DisclosureProps = {
  body?: string | ReactNode
  children?: ReactNode
  floating?: boolean
  header?: string
}

const Disclosure = ({
  body,
  children,
  floating = false,
  header,
}: DisclosureProps) => {
  const [isOpen, setIsOpen] = useState(false)

  const toggleIsOpen = () => setIsOpen(!isOpen)

  return (
    <DisclosureElement floating={floating}>
      <DisclosureContext.Provider value={{ floating, isOpen, toggleIsOpen }}>
        {header && <Header icon>{header}</Header>}
        {body && (
          <Body>
            {typeof body === 'string' ? <Paragraph>{body}</Paragraph> : body}
          </Body>
        )}
        {children}
      </DisclosureContext.Provider>
    </DisclosureElement>
  )
}

Disclosure.Body = Body
Disclosure.Header = Header
Disclosure.Icon = ArrowIcon

export * from './useDisclosureContext'
export type { DisclosureProps }
export { Disclosure }
